export const API_HOST = process.env.API_URL
export const API_PATH = '/'
